import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { useMemo } from 'react';

marked.use({ gfm: true, breaks: true });

function sanitized(markdown: string): string {
  const rendered = marked.parse(markdown, { async: false });
  const clean = DOMPurify.sanitize(rendered, {
    FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['style', 'srcdoc'],
  });
  const parsed = new DOMParser().parseFromString(clean, 'text/html');
  for (const link of parsed.querySelectorAll('a')) {
    const href = link.getAttribute('href') ?? '';
    if (!/^https?:\/\//iu.test(href) && !href.startsWith('#')) {
      link.removeAttribute('href');
    } else {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  }
  return parsed.body.innerHTML;
}

export function Markdown({ value }: { value: string }) {
  const html = useMemo(() => sanitized(value), [value]);
  return <div className="admin-markdown" dangerouslySetInnerHTML={{ __html: html }} />;
}
